import { RouteKeys } from "@/api_framework/api_modals/Routers";
import { useAppSelector } from "@/app_redux/hooks/root_hook";

/**
 * Feature-flag gate — DEFAULT-CLOSED.
 *
 * Returns true only if the current user's role has this featureId listed in
 * role_permission.actions (seeded via the RolesOnboard admin UI).
 *
 * Legacy role names are recorded in a comment above each call site so the
 * backend team knows which roles need to be seeded with each feature.
 */
export const useFeatureAccess = (featureId: RouteKeys): boolean => {
  const userPermissions = useAppSelector((state) => state?.auth?.userPermissions);
  const actions = userPermissions?.role_permission?.actions ?? [];
  return actions.includes(featureId);
};
